import { AdminService } from "../../services/admin-service";
import { NotifyService } from "../../services/notify-service";
import { IDivAvailsInfo } from "assets/app/ts/rlAdmin.models";


const assetFlag = 1 << 0;
const rightsetsFlag = 1 << 1;
const assetsAssetsFlag = 1 << 2;
const assetsRightsetsFlag = 1 << 3;
const truncateFlag = 1 << 4;

export class AvailsCalcAdminController {
    static $inject = ["$interval", "adminService", "notifyService"];

    jobID: string;
    recalc: boolean;
    resync: boolean;
    divIDs: string[];
    divID: number;

    zipRecalc: number;
    zipDivIDs: string[];

    zipFlags: number = assetFlag | rightsetsFlag | assetsAssetsFlag | assetsRightsetsFlag | truncateFlag;

    private hasZipFlag = (flag: number) => (this.zipFlags & flag) == flag;
    private setZipFlag = (flag: number, set: boolean) => {
        if (set) {
            this.zipFlags = this.zipFlags | flag;
        } else {
            this.zipFlags = ~flag & this.zipFlags;
        }
    };
    get zipAssetChecked() {
        return this.hasZipFlag(assetFlag);
    }
    set zipAssetChecked(value: boolean) {
        this.setZipFlag(assetFlag, value);
    }

    get zipRightsetChecked() {
        return this.hasZipFlag(rightsetsFlag);
    }
    set zipRightsetChecked(value: boolean) {
        this.setZipFlag(rightsetsFlag, value);
    }

    get zipAssetAssetChecked() {
        return this.hasZipFlag(assetsAssetsFlag);
    }
    set zipAssetAssetChecked(value: boolean) {
        this.setZipFlag(assetsAssetsFlag, value);
    }

    get zipAssetRightsetChecked() {
        return this.hasZipFlag(assetsRightsetsFlag);
    }
    set zipAssetRightsetChecked(value: boolean) {
        this.setZipFlag(assetsRightsetsFlag, value);
    }

    get zipTruncateChecked() {
        return this.hasZipFlag(truncateFlag);
    }
    set zipTruncateChecked(value: boolean) {
        this.setZipFlag(truncateFlag, value);
    }

    flags: number = assetFlag | rightsetsFlag | assetsAssetsFlag | assetsRightsetsFlag | truncateFlag;

    private hasFlag = (flag: number) => (this.flags & flag) == flag;
    private setFlag = (flag: number, set: boolean) => {
        if (set) {
            this.flags = this.flags | flag;
        } else {
            this.flags = ~flag & this.flags;
        }
    };
    get assetChecked() {
        return this.hasFlag(assetFlag);
    }
    set assetChecked(value: boolean) {
        this.setFlag(assetFlag, value);
    }

    get rightsetChecked() {
        return this.hasFlag(rightsetsFlag);
    }
    set rightsetChecked(value: boolean) {
        this.setFlag(rightsetsFlag, value);
    }

    get assetAssetChecked() {
        return this.hasFlag(assetsAssetsFlag);
    }
    set assetAssetChecked(value: boolean) {
        this.setFlag(assetsAssetsFlag, value);
    }

    get assetRightsetChecked() {
        return this.hasFlag(assetsRightsetsFlag);
    }
    set assetRightsetChecked(value: boolean) {
        this.setFlag(assetsRightsetsFlag, value);
    }

    get truncateChecked() {
        return this.hasFlag(truncateFlag);
    }
    set truncateChecked(value: boolean) {
        this.setFlag(truncateFlag, value);
    }

    intervalPromise: ng.IPromise<any>;
    jobProgress: number;
    jobTotal: number;
    jobStatus: string;
    jobComplete: number;
    jobMessage: string;



    divInfos: IDivAvailsInfo[];

    constructor(private $interval: ng.IIntervalService, private adminService: AdminService, private notifyService: NotifyService) {

    }

    $onInit() {
        this.recalc = true;
        this.resync = true;
        this.zipRecalc = 0;

        this.GetDivStatus();
    }

    parseDivIDs(input: string[]) {
        return input.map(i => +i);
    }

    Recalc() {
        this.notifyService.startProgress();
        this.adminService.resyncRecalcAvails(1, this.parseDivIDs(this.divIDs), this.resync, this.recalc, this.flags)
            .then((result) => {
                this.jobID = result.jobID;
                this.intervalPromise = this.$interval(() => this.UpdateState(), 2000);
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    ZipCalc() {
        this.notifyService.startProgress();
        this.adminService.resyncRecalcAvails(2, this.parseDivIDs(this.zipDivIDs), false, this.zipRecalc > 0, this.zipFlags)
            .then((result) => {
                this.jobID = result.jobID;
                this.intervalPromise = this.$interval(() => this.UpdateState(), 2000);
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    SyncDivInfo() {
        this.notifyService.startProgress();
        this.adminService.syncDivInfo(this.divID)
            .then((result) => {
                if (result) {
                    this.notifyService.notifySuccess(`Div ${this.divID} Info Synced`);
                }
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    GetDivStatus() {
        this.notifyService.startProgress();
        this.adminService.getDivAvailsInfoList()
            .then((results) => {
                this.divInfos = results;
            })
            .finally(() => {
                this.notifyService.endProgress();
            })
    }

    UpdateState() {
        this.adminService.getJobState(this.jobID)
            .then((result) => {
                this.jobComplete = result.completed;
                // this.MergeMessages(result.infoMessages);
                this.jobMessage = result.progressMessage;
                this.jobStatus = result.status;
                this.jobTotal = result.total;
                this.jobProgress = (this.jobComplete / this.jobTotal) * 100;

                if (result.status == "Done" || result.status == "Failed" || result.status == "Cancelled") {
                    this.$interval.cancel(this.intervalPromise);
                    if (result.status == "Cancelled") {
                        // stop the spinning cancel button
                        this.notifyService.broadcastDone();
                    }
                }
            }, () => {
                // this.jobStateFailCount++;
                // if (this.jobStateFailCount > 5) {
                //     this.$interval.cancel(this.intervalPromise);
                //     this.jobStatus = "Error";
                //     this.notifyService.notifyError("Error updating job status");
                //     this.jobStateFailCount = 0;
                // }
            });
    }

    CancelJob($event: Event) {
        $event.preventDefault();
        this.adminService.cancelJob(this.jobID)
            .then(() => {
                // success
            }, () => {
                this.notifyService.notifySuccess("Error Cancelling Job");
            })
            .finally(() => {
                //this.notifyService.endProgress();
            });

    }
}